import { BackgroundSun } from './BackgroundSun'

export default BackgroundSun
